import { Component, Input, OnDestroy, ViewContainerRef } from '@angular/core'
import { ActivatedRoute } from '@angular/router'
import { Subscription } from 'rxjs'
import { Footnote } from 'src/app/models/footnote.model'
import { AEMChunk } from 'src/app/services/AEM/aem-chunk.model'
import { CentralContentService } from 'src/app/services/content/central-content.service'
import { RiskService } from 'src/app/services/risk/risk.service'

@Component({
  selector: 'historical-measures',
  templateUrl: './historical-measures.component.html',
  styleUrls: ['./historical-measures.component.scss'],
  providers: [],
})
export class HistoricalMeasuresComponent implements OnDestroy {
  @Input() performanceModel: any
  @Input() benchmarkFootNote: Footnote
  @Input() rSquaredBetaFootnote: Footnote
  @Input() isValidSinceInceptionDate: boolean

  profileData: object
  dataType = 'monthEndAvgAnnualRtn'
  tickerOrFundId: string
  dialogTitle: string
  dialogBody: string

  rSquaredDescription: AEMChunk
  betaDescription: AEMChunk
  aemContentSub: Subscription

  // eslint-disable-next-line complexity, max-params
  constructor(
    private readonly riskService: RiskService,
    public readonly route: ActivatedRoute,
    public viewContainer: ViewContainerRef,
    private readonly centralContentService: CentralContentService,
  ) {}

  ngOnInit() {
    this.aemContentSub = this.centralContentService.aemContent$.subscribe(
      (content) => {
        this.parseAEMContent(content)
      },
    )
  }

  parseAEMContent(content) {
    this.rSquaredDescription = this.centralContentService.getContentByBody(
      'fund_definitions_r_squared',
      content,
    )
    this.betaDescription = this.centralContentService.getContentByBody(
      'fund_definitions_beta',
      content,
    )
  }
  public setDialogInfo(title: string) {
    this.dialogTitle = title
    if (title === 'Beta') {
      this.dialogBody = this.betaDescription?.contentValue
    } else if (title === 'R-Squared') {
      this.dialogBody = this.rSquaredDescription?.contentValue
    }
  }

  ngOnDestroy(): void {
    this.aemContentSub.unsubscribe()
  }
}
